import { updatePlan } from './updatePlanThunk';
export default updatePlan;
